module.exports = __webpack_public_path__ + "img/beige-ribbon.aebfcdd2.svg";